import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ClientAuthProvider } from "@/context/ClientAuthContext";
import { LightProvider } from "@/context/LightContext";
import SpotlightOverlay from "@/components/SpotlightOverlay";
import AmbientGlow from "@/components/AmbientGlow";
import LitCatchController from "@/components/LitCatchController";
import SmoothScroll from "@/components/SmoothScroll";
import SoundToggle from "@/components/SoundToggle";
import Home from "@/pages/Home";
import RealEstate from "@/pages/RealEstate";
import LocalBusiness from "@/pages/LocalBusiness";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ProtectedRoute from "@/components/ProtectedRoute";
import ClientProtectedRoute from "@/components/ClientProtectedRoute";
import ClientLogin from "@/pages/portal/ClientLogin";
import ForgotPassword from "@/pages/portal/ForgotPassword";
import ResetPassword from "@/pages/portal/ResetPassword";
import ClientDashboard from "@/pages/portal/ClientDashboard";
import { Toaster } from "sonner";

function App() {
    return (
        <AuthProvider>
            <ClientAuthProvider>
                <LightProvider>
                    <BrowserRouter>
                        <SmoothScroll />
                        <AmbientGlow />
                        <SoundToggle />
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/real-estate" element={<RealEstate />} />
                            <Route path="/local-business" element={<LocalBusiness />} />
                            <Route path="/admin" element={<AdminLogin />} />
                            <Route
                                path="/admin/dashboard"
                                element={
                                    <ProtectedRoute>
                                        <AdminDashboard />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="/portal" element={<ClientLogin />} />
                            <Route path="/portal/forgot-password" element={<ForgotPassword />} />
                            <Route path="/portal/reset-password" element={<ResetPassword />} />
                            <Route
                                path="/portal/dashboard"
                                element={
                                    <ClientProtectedRoute>
                                        <ClientDashboard />
                                    </ClientProtectedRoute>
                                }
                            />
                        </Routes>
                        <SpotlightOverlay />
                        <LitCatchController />
                    </BrowserRouter>
                </LightProvider>
            </ClientAuthProvider>
            <Toaster
                position="top-center"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#4A0505",
                        color: "#FDFBF7",
                        border: "1px solid rgba(212,175,55,0.3)",
                    },
                }}
            />
        </AuthProvider>
    );
}

export default App;
